import React from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import { usePhaseTemplateForm } from "../../../hooks/annual-planner/usePhaseTemplateForm";
import { useRillContext } from "../../../rill/RillReact/share/base";
import Modal from "../../modal-new";
import { PhaseTrackColumn } from "./parts/PhaseTrackColumn";

export const EditTemplateModal = ({ templateId, organizationCoachId }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const { locals } = useRillContext();

  const {
    phasesTemplates: { templates },
  } = locals;

  const currentTemplate = templates.find(
    (template) => template._id === templateId
  );

  const {
    phase_template_name,
    trainingRows,
    nutritionRows,
    emptyPhasesState,
    handleFieldChange,
    handlePhaseChange,
    handleAddPhase,
    handleRemovePhase,
    handleSubmit,
  } = usePhaseTemplateForm({
    getInitialState: () => ({
      phase_template_name: currentTemplate.templateName,
      // Phases saved before the `track` field existed have none - they were
      // always training-only, so a missing track defaults there.
      phases: currentTemplate.phases.map((phase) => ({
        ...phase,
        track: phase.track || "training",
      })),
    }),
    onSubmit: (payload) => {
      let body = { templateId, ...payload };
      if (organizationCoachId) {
        body = { ...body, organizationCoachId };
      }

      submit("/actions/annual-planner/update-phase-template", {
        method: "POST",
        body,
      });
    },
  });

  return (
    <Modal
      className="annual-planner-modal add-phase-template-modal"
      title={t("editTemplateModal.title")}
    >
      <div className="body">
        <form
          id="edit-phase-template-form"
          className="annual-planner-modal-form add-phase-template-modal-form"
          onSubmit={handleSubmit}
          encType="multipart/form-data"
        >
          <div role="wrapper" className="template-name">
            <label className="label">
              {t("editTemplateModal.phaseGroupNameLabel")}
            </label>
            <input
              type={"text"}
              name="phase_template_name"
              className="phase-template-name text-input"
              placeholder={t("editTemplateModal.placeholderGroupName")}
              defaultValue={phase_template_name}
              onChange={({ target: { value } }) =>
                handleFieldChange("phase_template_name", value)
              }
            />
          </div>
          <div className="phase-tracks-columns">
            <PhaseTrackColumn
              title={t("phaseTracks.training")}
              rows={trainingRows}
              placeholderPhaseName={t("editTemplateModal.placeholderPhaseName")}
              addNewLabel={t("editTemplateModal.addNew")}
              onAddPhase={() => handleAddPhase("training")}
              onChangePhase={handlePhaseChange}
              onRemovePhase={handleRemovePhase}
            />
            <PhaseTrackColumn
              title={t("phaseTracks.nutrition")}
              rows={nutritionRows}
              placeholderPhaseName={t("editTemplateModal.placeholderPhaseName")}
              addNewLabel={t("editTemplateModal.addNew")}
              onAddPhase={() => handleAddPhase("nutrition")}
              onChangePhase={handlePhaseChange}
              onRemovePhase={handleRemovePhase}
            />
          </div>
        </form>
      </div>
      <footer className="phase-template-footer">
        <button
          type="button"
          role="button"
          data-action="cancel"
          onClick={() =>
            submit("/actions/refresh?", {
              method: "GET",
              body: {
                "modal[type]": "",
              },
            })
          }
        >
          {t("common:cancel")}
        </button>
        <button
          type="button"
          form="add-phase-template-form"
          role="button"
          data-button-type="primary"
          disabled={emptyPhasesState}
          onClick={handleSubmit}
        >
          {t("common:save")}
        </button>
      </footer>
    </Modal>
  );
};
